import React from 'react';

export const Link = props => {
  return <a {...props}>{props.children}</a>;
};
